var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Twitterx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 18.058594 2.9921875 A 0.750075 0.750075 0 0 0 17.490234 3.2675781 L 12.767578 8.9082031 L 9.0566406 3.7714844 C 8.7066406 3.2874844 8.1458281 3 7.5488281 3 L 4.078125 3 C 3.420125 3 3.0388281 3.7462969 3.4238281 4.2792969 L 9.546875 12.755859 L 3.6757812 19.767578 A 0.750075 0.750075 0 1 0 4.8242188 20.732422 L 10.451172 14.009766 L 14.943359 20.228516 C 15.293359 20.712516 15.854172 21 16.451172 21 L 19.921875 21 C 20.579875 21 20.961172 20.253703 20.576172 19.720703 L 13.673828 10.164062 L 18.640625 4.2324219 A 0.750075 0.750075 0 0 0 18.058594 2.9921875 z M 5.4335938 4.5 L 7.5507812 4.5 C 7.6657813 4.5 7.7747969 4.5554375 7.8417969 4.6484375 L 18.566406 19.5 L 16.451172 19.5 C 16.336172 19.5 16.227156 19.444562 16.160156 19.351562 L 11.34375 12.683594 A 0.750075 0.750075 0 0 0 10.822266 11.960938 L 5.4335938 4.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Twitterx);
export default __webpack_public_path__ + "static/media/icons8-twitterx.7d0bc49f9c91ea94d2b24a6aaca3ee43.svg";
export { ForwardRef as ReactComponent };